module.exports = __webpack_public_path__ + "static/media/education2.0662fa49.svg";